import i18next from "i18next";
import { Link } from "react-router-dom";
import { LogoLink, LogoSubtitle, LogoText, LogoWrapper, Wrapper } from "./style";

const HeaderLogoComponent = () => {
  const { t } = i18next;

  return (
    <Wrapper>
      <LogoLink to="/">
        <img src="/images/logo.png" alt="Aviabozor logo" />
        <LogoWrapper>
          <LogoText>Aviabozor</LogoText>
          <Link to="/scoreboard">
            <LogoSubtitle>{t("online_airport_board") || "Online airport board"}</LogoSubtitle>
          </Link>
        </LogoWrapper>
      </LogoLink>
    </Wrapper>
  );
};

export default HeaderLogoComponent;
